import React from 'react';

import { Root } from '@atlassian/navigation-system/layout/root';
import { TopBar } from '@atlassian/navigation-system/layout/top-bar';
import {
	CommonActions,
	HomeActions,
	UserActions,
} from '@atlassian/navigation-system/top-nav-items';

export const TopBarLayoutExample = () => (
	<Root>
		<TopBar>
			<HomeActions>123</HomeActions>
			<CommonActions>456</CommonActions>
			<UserActions>789</UserActions>
		</TopBar>
	</Root>
);
